module.exports = __webpack_public_path__ + "static/img/img18.7efca88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img18.jpg
// module id = Yi0v
// module chunks = 1